// extracted by mini-css-extract-plugin
export var imageWrapper = "PortableHeader-module--imageWrapper--1c3e7";
export var subtitle = "PortableHeader-module--subtitle--b8066";
export var wrapper = "PortableHeader-module--wrapper--735ea";